import styled from 'styled-components'

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  text-align: center;
  position: relative;
`
